<template>
	<div :class="showContent ? 'container':'container-ac'">
		<div class="content" v-show="showContent">
			<div class="train-content">
				<img src="../assets/images/train-bg.png" alt="" class="train-bg">
				<div class="train-main">
					<div class="train-title">{{trainName}}</div>
					<div class="time-box">
						<div class="time-long">
							<img src="../assets/images/emotion_time.png" alt="" srcset="" class="time-icn">
							<div class="long">时长</div>
						</div>
						<div class="time-text">{{ allTime }}</div>
					</div>
					<div class="train-des" v-if="trainName=='正念冥想'">
						正念是指对当下体验的有意识的非评价的觉察，强调对此时此地实际身心感受接纳与觉知，并且鼓励不在这种接纳和觉知中加入评判。</div>
					<div class="train-des" v-if="trainName=='美人技术'">
						美人技术是动力沟通理论指导下的特有的以增进自我觉察为目的技术。美人技术是综合性的技术，强调存在、体验、行动、理解、目标和肯定这六个要素，按照这六个维度进行练习，面容和心灵会越来越美丽，越来越安详，越来越能觉察自己的内部的欲望、需要、情感和冲突，也越来越能觉察周围他人的欲望、需要、情感和冲突，与周围的人、事和环境会越来越协调、越来越有创造性。
					</div>
				</div>
			</div>
			<div class="go">
				<div class="go-box">
					<div class="go-btn" @click="go">马上参与</div>
				</div>
			</div>
		</div>
		<div class="main" v-show="!showContent">
			<div class="train-pic">
				<img src="../assets/images/recommended-pic.webp" alt="" />
			</div>
			<div class="train-name">{{trainName}}</div>
			<div class="control">
				<img src="../assets/images/play.png" alt="" class="play" v-show="nowControl == 'play'" @click="play" />
				<img src="../assets/images/pause.png" alt="" class="pause" v-show="nowControl == 'pause'"
					@click="pause" />
			</div>
			<div class="step-box">
				<div class="step">
					<div class="step-line" :style="{ width: press + '%' }"></div>
					<div class="step-dot" :style="{ left: (press / 100) * 250 - 6 + 'px' }"></div>
				</div>
				<div class="now-all">
					<div class="now">{{ nowTime }}</div>
					<div class="all">{{ allTime }}</div>
				</div>
			</div>
			<audio src="../assets/train-audio/正念冥想.mp3" type="audio/mp3" controls="controls" @timeupdate="update"
				@canplay="all" @ended="end" class="music" id="m1"></audio>
			<audio src="../assets/train-audio/美人技术.mp3" type="audio/mp3" controls="controls" @timeupdate="update"
				@canplay="all" @ended="end" class="music" id="m2"></audio>
<!-- 			<audio v-if="trainName=='正念冥想'" src="https://www.qingxusuanfa.com/public/audio/正念冥想.mp3" type="audio/mp3" controls="controls" @timeupdate="update" @loadstart="loadaudio"
				@canplay="all" @ended="end" class="music" id="m1"></audio>
			<audio v-if="trainName=='美人技术'" src="https://www.qingxusuanfa.com/public/audio/美人技术.mp3" type="audio/mp3" controls="controls" @timeupdate="update" @loadstart="loadaudio"
				@canplay="all" @ended="end" class="music" id="m2"></audio> -->
		</div>
	</div>
</template>
<script>
	import urlencode from "urlencode"
	import { sha256 } from 'js-sha256'
	import moment from 'moment'
	import {
		add_train,service_resource
	} from '../api/server'
	import {
		Dialog,
	} from 'vant';
	export default {
		components: {
			[Dialog.Component.name]: Dialog.Component,
		},
		data() {
			return {
				showContent: true,
				imei: '',
				loginPhone: '',
				m1: null,
				nowControl: "play",
				allTime: "",
				nowTime: "00:00",
				press: "",
				isFirst: true,
				startTime: '',
				endTime: '',
				trainSrc: '',
				trainName: '',
				timerVar: null,
				exerciseAlltime: 3600,
				exerciseNewTime: 0,
				toasts:null,
				appid:'BIXIN',
				method:'heartide.bixin.audio.recommend',
				data:'{"recommend_type":1,"recommend_size":5}',
				timestamp:'',
				app_key:'wGfzIPMMUofuS2s2aHPHxASLTfn4LjWE',
				sign:'',
				paramsData:null,
				resData:''
			};
		},
		computed: {},
		methods: {
			goBack() {
				this.$router.go(-1)
			},
			go() {
				this.showContent = false;
			},
			play() {
				if (this.isFirst) {
					let date = new Date();
					let time = parseInt(date.getTime() / 1000)
					this.startTime = time;
				}
				this.isFirst = false;
				this.m1.play();
				this.nowControl = "pause";
			},
			pause() {
				this.m1.pause();
				this.nowControl = "play";
				let date = new Date();
				let time = parseInt(date.getTime() / 1000)
				this.endTime = time;
				add_train(this.loginPhone, this.imei, this.startTime, this.endTime, 'train', '正念冥想').then(res => {
					if (res.status == 200) {
						this.$router.push({
							path: '/train-report',
							query: {
								id: res.data.trainData[0].id
							}
						})
					}
				})
			},
			update() {
				//let audio = document.getElementById("m1");
				let audio;
				let time = 0;
				let nowTime = 0;
				audio = this.m1;
				time = audio.duration; //获取总播放时间      
				nowTime = audio.currentTime; //获取播放进度

				let minutesA = parseInt(nowTime / 60);
				if (minutesA < 10) {
					minutesA = "0" + minutesA;
				}
				let secondA = Math.round(nowTime % 60);
				if (secondA < 10) {
					secondA = "0" + secondA;
				}
				let startTime = minutesA + ":" + secondA;
				this.nowTime = startTime;
				let press = (nowTime / time) * 100;
				this.press = press;
			},
			all() {
				if(this.toasts){
					this.toasts.clear()
				}
				let audio = this.m1;
				let time = audio.duration; //获取总播放时间
				if (!time) {
					time = 0;
				}
				let minutes = parseInt(time / 60);
				if (minutes < 10) {
					minutes = "0" + minutes;
				}
				let second = Math.round(time % 60);
				if (second < 10) {
					second = "0" + second;
				}
				let allTime = minutes + ":" + second;
				this.allTime = allTime;
			},
			end() {
				this.m1.pause();
				this.nowControl = "play";
				let date = new Date();
				let time = parseInt(date.getTime() / 1000)
				this.endTime = time;
				add_train(this.loginPhone, this.imei, this.startTime, this.endTime, 'train', this.trainName).then(res => {
					if (res.status == 200) {
						this.$router.push({
							path: '/train-report',
							query: {
								id: res.data.trainData[0].id
							}
						})
					}
				})
			}
		},
		created() {
			let imei = localStorage.getItem('imei');
			this.imei = imei;
			let phone = localStorage.getItem('phone');
			this.loginPhone = phone;
			if (this.$route.query.train == '正念冥想') {
				this.trainName = '正念冥想'
				this.allTime = "09:43"
			}
			if (this.$route.query.train == '美人技术') {
				this.trainName = '美人技术'
				this.allTime = "07:01"
			}
		},
		mounted() {
			if (this.trainName == '正念冥想') {
				this.m1 = document.getElementById("m1");
			}
			if (this.trainName == '美人技术') {
				this.m1 = document.getElementById("m2");
			}
		},
	};
</script>
<style lang='less' scoped>
	.container {
		height: 100vh;
		width: 100vw;
	}

	.container-ac {
		height: 100vh;
		width: 100vw;
		background-color: rgba(49, 59, 59, 0.3);
	}

	.content {
		padding: 16px;
	}

	.train-content {
		background-color: #fff;
		border-radius: 10px;
	}

	.train-bg {
		display: block;
		width: 100%;
		height: 142px;
		border-radius: 10px 10px 0px 0px;
	}

	.train-main {
		padding: 12px;
		border-radius: 0px 0px 10px 10px;
	}

	.train-title {
		margin-top: 8px;
		margin-bottom: 20px;
		line-height: 20px;
		font-size: 20px;
		font-weight: 500;
		color: #333;
	}

	.time-box {
		height: 40px;
		background-color: #FBFCFC;
		border-radius: 20px;
		padding: 0px 12px;
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
	}

	.time-long {
		margin-top: 8px;
		height: 24px;
		display: flex;
		justify-content: flex-start;
	}

	.time-icn {
		height: 24px;
		width: 24px;
	}

	.long {
		height: 24px;
		line-height: 24px;
		font-size: 12px;
		color: #999999;
		margin-left: 8px;
	}

	.time-text {
		margin-top: 8px;
		height: 24px;
		line-height: 24px;
		font-size: 14px;
		font-weight: 500;
		color: #333;
	}

	.train-des {
		line-height: 26px;
		font-size: 14px;
		color: #666666;
		text-indent: 2em;
	}

	.go {
		position: fixed;
		left: 0px;
		bottom: 0px;
		width: 100%;
		z-index: 10;
	}

	.go-box {
		background-color: #fff;
		padding: 10px 16px;
	}

	.go-btn {
		height: 50px;
		line-height: 50px;
		border-radius: 25px;
		text-align: center;
		font-size: 16px;
		font-weight: 500;
		color: #fff;
		background-color: #01D6D6;
	}

	@media (min-width: 768px) {

		/*0~768*/
		.go-box {
			width: 400px;
			margin: 0 auto;
		}
	}

	.main {
		padding-top: 90px;
	}

	.train-pic {
		height: 180px;
		width: 180px;
		margin: 0 auto;
		border-radius: 50%;
		border: 2px solid #fff;
	}

	.train-pic img {
		display: block;
		height: 180px;
		width: 180px;
		border-radius: 50%;
	}

	.train-name {
		height: 60px;
		line-height: 60px;
		text-align: center;
		font-size: 20px;
		font-weight: 500;
		color: #fff;
		margin-bottom: 104px;
	}

	.control {
		height: 80px;
		margin-bottom: 90px;
	}

	.play {
		display: block;
		height: 80px;
		width: 80px;
		border-radius: 50%;
		margin: 0 auto;
	}

	.pause {
		display: block;
		height: 80px;
		width: 80px;
		border-radius: 50%;
		margin: 0 auto;
	}

	.step-box {
		width: 250px;
		margin: 0 auto;
	}

	.step {
		height: 4px;
		background-color: #777871;
		border-radius: 2px;
		position: relative;
	}

	.step-line {
		height: 4px;
		position: absolute;
		left: 0px;
		top: 0px;
		background-color: #fff;
		width: 0px;
	}

	.step-dot {
		height: 12px;
		width: 12px;
		border-radius: 50%;
		background-color: #fff;
		position: absolute;
		left: -6px;
		top: -4px;
	}

	.now-all {
		margin-top: 8px;
		display: flex;
		justify-content: space-between;
	}

	.now {
		height: 12px;
		line-height: 12px;
		font-size: 10px;
		font-weight: 900;
		color: #fff;
	}

	.all {
		height: 12px;
		line-height: 12px;
		font-size: 10px;
		font-weight: 900;
		color: #fff;
	}

	.music {
		display: none;
	}

	.ulstyle {
		list-style: decimal inside;
	}

	.go-btn-canel {
		height: 50px;
		line-height: 50px;
		border-radius: 25px;
		text-align: center;
		font-size: 16px;
		font-weight: 500;
		color: #fff;
		background-color: none;
	}
</style>
